import { setAuthState } from './auth';

export const AUTOAPPLY_QUEUE = 'autoapply-queue';

let snapshot = null;

// Switches AutoApply between today's flow and the queue. The AutoApply tab, the add-to-queue click
// and the queue tutorials must all gate through this, never userHaveAccessTo() directly: that reads
// localStorage on every call, and App.vue's /api/user refresh or any setUser() can rewrite `features`
// mid-page. The first read is kept for the rest of the page load, per user, so the two flows never mix.
export const isAutoApplyQueueEnabled = () => {
	const { getUser, userHaveAccessTo } = setAuthState();
	const userId = getUser()?.id ?? null;

	if (snapshot?.userId !== userId) {
		snapshot = { userId, enabled: userHaveAccessTo(AUTOAPPLY_QUEUE) };
	}

	return snapshot.enabled;
};
